import { connect } from 'react-redux';
import CancelCard from './CancelCard';
import { cancelCardConfirm, cancelCardReject } from '../../settings/LostCard/actions';

const mapDispatchToProps = {
  cancelCardAction: cancelCardConfirm,
  abortAction: cancelCardReject
};

export default connect(null, mapDispatchToProps)(CancelCard);
